module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chapter"
  }, [_vm._v("Chapter Three")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Not by the hair on your chinny-chin-chin!")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I backed away from the door. Gloriana backed with me, still glaring at the door. Whoever was on the other side of it was not on her list of favourite people. We were as one on that.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Darling?’ The insistent voice began to falter. ‘Are you awake?’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Who was this man? And how much else was there that Nessa hadn’t told me?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Quite a lot, obviously. Perhaps she had planned to tell me all about it when I arrived. And yet … and yet … I had had no flash of intuition to tell me that she was emotionally involved. Was that because the essential closeness of twinship was breached when True Love entered the equation?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I wouldn’t know. Whatever brief encounters had come my way had been amusing and, in their way, fulfilling, but nothing that could be categorized as True Love. Not yet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Darling …’ He was giving up. Perhaps he felt too exposed, standing at the near end of the cloister, tapping on an unyielding door. ‘Sleep well, then. Until the morrow. I’ll be busy all day, but the night … the night will be our own!’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("That’s what you think!")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Morrow? The night will be our own?")]), _vm._v(" Who was this ham? What was Nessa doing tied up with him? Had she lost her sense of humour—or her mind?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Whoever he was, Romeo was not going to be the one to "), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v(" make any dent in my amnesia. He was going straight back to being a stranger—and staying there. So far as I was concerned, we had not been introduced.")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("On the other hand, Gloriana and I appeared to be bonding after our experience with the voice on the other side of the door. Clearly, she approved of my not letting him in. I felt soft fur brush my ankle lightly as we returned to the bedroom. She was the only one I was going to share it with tonight.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sleep …? I lay there staring into darkness. How could I have imagined, even for one insane moment, that sleep would be possible? In a strange bed … in a strange house … surrounded by strangers?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("And isn’t that a definition of any hotel you’ve ever stayed in? ")]), _vm._v("The reasonable side of my brain tried to calm me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Not quite.")]), _vm._v(" I would not be soothed. In this place, one of the strangers was an enemy. Perhaps more than one. And who knew what else one or more of them might be?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("How many of them were there? What were they to Nessa? Or she to them? This was the first time she had ever taken on a residential job. Had she been enjoying it—or had she begun to regret it?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I turned over restlessly and punched a dent in the pillow. It was too dark here, too quiet. At least, in a hotel, there were sounds of life around you. Normal life. Loud voices, laughter, the boom of a television set, an occasional snatch of drunken song … and unashamed footsteps noisily heading towards their rightful room.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I found myself listening again for the furtive steps shuffling outside my door. Stupid, of course. Beloved had long since drifted away to his own lair. Secrecy seemed to be paramount; he would not want anyone to catch him loitering outside Nessa’s quarters.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("Outside, there were the sounds of the night. The wind rising, a splatter of rain—good, that would discourage any other incipient prowlers. In the distance, guard dogs barked … except for the one that howled. Another splatter of rain told me there was no moon for it to howl at. ")]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Night has a thousand sounds … and a thousand eyes. I could feel them watching me now. For an uneasy moment, I wondered whether there was a spyhole in one of the walls … or a hidden camera.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A faint whisper of sound, close by, and I turned to find that the cat was crouching in the bedside armchair and was watching me intently … suspiciously.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh, come along,’ I said, patting the bed. ‘Come over and let’s get acquainted.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Oooops!")]), _vm._v(" I had offended the Dowager Duchess again. Her head reared back, her eyes went icy. The temporary truce that had ensued when I ignored Beloved was over. We were back on barely nodding terms again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘All right, be like that.’ I turned over. ‘See if I care.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But I did. If we couldn’t reach a semblance of amity, if not intimacy, she might blow my cover. In her current amnesiac condition, ‘Nessa’ might not remember her cat, but the cat would be expected to recognize and welcome Nessa. A loving cat can only maintain a snit at her mistress for a limited time. If the Duchess didn’t come round soon, I could be in trouble.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent_2"
  }, [_vm._v("They say you never have a really sleepless night, it’s just an illusion; that, actually, you have a series of catnaps in between the periods of wakefulness. It’s because the wake-fulness is so clear and worrying that it seems never to have ended.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Perhaps I did sleep, after all. At some point, I must have drifted off. Suddenly, the room was noticeably brighter, the cat was gone from the armchair, and there were faint sounds of the world moving back into action in the distance. A car motor roared, a dog barked—a different kind of dog—not the deep menacing snarling bark of the guard dogs, this sounded like a more normal dog, one you might be able to reason with. Some sort of bird cried out plaintively … a seagull? How near the sea were we?")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("No point in lying here any longer. Time to get up and ")]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v(" face what the day might bring. Face … yes, a quick close shave first thing, before anyone came calling, and a light application of foundation cream, dappled with a judicious overlay of darker shades to simulate fading bruises.")])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("That accomplished, I did a quick survey of what was available in Nessa’s wardrobe. Luckily, we were both tall and had the same build, typical twins. The fit would be no problem.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Especially with the full-length kaftans we both loved. I knew she had a full wardrobe of them—I had provided it myself. My early years as an entertainer on the cruise ships plying the Mediterranean, the Caribbean, and even more exotic locations had provided great shopping opportunities and I had stocked up with costumes and kaftans for both of us. Who would have thought that they would come in so useful this far in the future?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The more businesslike everyday outfits she had chosen for herself were about what I would have expected. Excellent materials, beautifully cut, but in muted colours, designed to be quiet and unobtrusive. Just what I would have chosen myself to dress the act. A good secretary doesn’t outshine her employer’s ladies. Not if she’s wise.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("No, nothing wrong with the costumes in themselves, except … I could feel my frown deepening. Something wasn’t quite right. I walked into the closet for a closer inspection.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The light didn’t work. I flipped the switch several times before looking up to discover that the bulb was missing. I settled for propping the door open with a stray shoe and looked around.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At first, nothing to cause disquiet was immediately apparent. Here and there a hanger hung askew, the garment half slipping off it, and there were uneven spaces between the hangers. Not like Nessa.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then, as my eyes grew accustomed to the dim light, I noticed the sleeve of a jacket, half inside out, and the lining of a pocket protruding from another jacket.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("Moving forward to investigate, I stumbled over a pile of ")]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v(" shoes in the middle of the floor. I recognized the mate to the one I had propped the door open with. The others were all jumbled together, instead of being lined up in matching pairs as Nessa usually kept them.")])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Had Nessa dressed hurriedly that last night, changing whatever she had been wearing for something more suitable for outdoors? And why had she gone out into the cold and darkness where relentless guard dogs patrolled the grounds? Had she been summoned? By whom? And why?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The whole set-up whispered of haste and urgency. But was it on Nessa’s part—or was there another reason?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I stepped back into the bedroom, kicking the doorstop shoe into the pile with the others and letting the door close behind me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One after the other, I pulled open the dressing-table drawers and looked down into them. Into the uneven heaps that had once been neat tidy piles of Nessa’s underclothes and personal belongings. There was now no doubt about it: the place had been thoroughly, if amateurishly, searched.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And what about her desk? Surely that would have been a prime target. I turned towards the living room to see—in the cold light of day and the cold knowledge I had gained—just what I might have missed the night before.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I had forgotten the cat again. She sat beside the door opening into the cloister, staring at me accusingly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘No, you can’t go out,’ I said. ‘You heard those dogs last night. Some of them might still be around. I’m sure you’re not an outside cat, anyway.’ Nessa would never have allowed her precious pet to run loose in such dangerous territory. What a shame she hadn’t taken the same precaution herself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The cat flicked her ears irritably. I wasn’t getting the message. She rose slowly and pointedly began to sniff along the bottom of the door.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("Then I saw it. A small white triangle slipped beneath the door. I stooped and pulled it towards me cautiously. ")]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Not a message from Beloved, I hoped, although I wouldn’t put it past him. Even more cautiously, I opened the envelope—and relaxed.")]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Good morning, Vanessa.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I didn’t want to wake you (Dr Anderson "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("emphasized ")]), _vm._v("the importance of your getting plenty of rest), so you’ll find brunch just outside.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We all hope you’ll feel able to join us for dinner this evening. We gather in the library at 6:30 for 7:00.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If you need anything or have any questions, please contact me at H1 on your interior phone.")]), _vm._v(" "), _c('p', {
    staticClass: "center_3"
  }, [_vm._v("Monica")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The cat was dancing with impatience while I read the message. Now that I thought of it, I was hungry. I checked my watch: 11:45. How time flies when you’re having fun!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Holding the cat back with one foot, I eased the door open and looked up and down the cloister walk. It was deserted. An elaborate hostess trolley stood just outside the door. I tried to keep the cat away while I opened the door wide enough to roll the trolley inside.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I needn’t have worried. She wasn’t going anywhere. Not now that the trolley was on her side of the door. She hurled herself against my ankles, nearly tripping me and purring enthusiastically.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The truce was on again. At least until she had cajoled a goodly portion of my brunch away from me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘I’m hungry, too,’ I told her. ‘But don’t worry. There’s enough in here for a regiment.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A warming compartment held scrambled eggs, bacon, sausages and—in case they didn’t appeal—kedgeree. Also an assortment of rolls and croissants.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("A cool compartment beneath it had pots of yogurt, orange juice, small jugs of milk and cream, pats of butter, both salted and unsalted, and a variety of cheeses, all keeping nicely chilled. ")]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The last panel revealed a neutral compartment holding a selection of fruit and Danish pastries.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("‘Prryah-yah-yah!’ ")]), _vm._v("my new best friend enthused, pawing at the warming compartment. She couldn’t wait.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Oh, all right,’ I surrendered. The warmed plates were in a wide lower drawer and I took two out, piling a bit of everything on hers and rather more of everything on mine, and we settled down to a long satisfying meal.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Old habits die hard—and why shouldn’t they? When we had eaten our fill, I salvaged the remaining cheeses, butter, jams and a couple of rolls and folded them into a napkin and secreted them at the bottom of a drawer. In a place like this, you never could tell when you might get your next meal.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The cat watched with approval. She was indifferent to the rolls and jam, but she had a vested interest in those luscious cheeses.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Just in case,’ I told her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She blinked agreement, just before she slumped across my feet and conked out, her little tummy bulging.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I wondered when she had last been fed—and how well. She had gulped down everything on offer, even the scrambled eggs, like some stray unsure of when—or what—her next meal would be.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But she had the right idea. I yawned. A little catnap right now was not to be despised. It was not just the heavy meal, it had been a pretty sleepless night. I vaguely recognized that I was also probably experiencing some sort of delayed shock after the last few days.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("I gathered up the cat’s unprotesting form and carried her into the bedroom where we both collapsed on to the bed and into those everloving arms of Morpheus. ")]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-081c4672","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Chapter_3.vue
// module id = 81
// module chunks = 0